var t=/^(?=.{3,30}$)([\s]*[\u0020\u0021\u0023-\u0026\u0028-\u003B\u003D\u003F-\uFFFF]?)*$/is;function e(u){return t.test(u)}export{t as a,e as b};
